import { Injectable } from 'angular-ts-decorators';

import { SpynlBase } from '@shared/app/scripts/services/spynl-base';
import { IStandardErrorParser } from '@shared/app/scripts/services/standard-error-parser';

/**
 * Factory in the coreModule. It takes care of communication with buffer
 * resource. Methods are inherited form {@link shared.spynlBase
 * spynlBase} service, and are documented there.
 *
 * # Data schema
 * {@link http://docs.dev.swcloud.nl/schemas/bower_components/docson/#../../spynl/buffer.json
 * is documented with json-schema}
 */
@Injectable('buffer')
export class Buffer extends SpynlBase<Object> {
  protected location: string;
  constructor(
    $http,
    $q,
    sentry,
    domain,
    config,
    standardErrorParser: IStandardErrorParser,
  ) {
    'ngInject';

    super($http, $q, sentry, domain, config, standardErrorParser, Object);
    this.location = '/buffer';
  }
}
